import React from "react";
import { Link } from "react-router-dom";
import { Package, Info, Palette } from "lucide-react";

const CTASections = () => {
  const ctaItems = [
    {
      title: "EXPLORE OUR PRODUCTS",
      subtitle: "Browse Our Flooring Collections",
      icon: Package,
      link: "/products",
      image: "https://images.unsplash.com/photo-1575204015311-0fe377370780?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsYW1pbmF0ZSUyMGZsb29yaW5nfGVufDB8fHx8MTc2NTgzNTE3M3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "ABOUT TIMBERLAKE FLOORING",
      subtitle: "Discover Our Story",
      icon: Info,
      link: "/about",
      image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NTgzNTE4NHww&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "ROOM VISUALIZER",
      subtitle: "Pick Your Own Flooring Vibe",
      icon: Palette,
      link: "/visualizer",
      image: "https://images.unsplash.com/photo-1598718544285-7180f670198b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHx2aW55bCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NTgzNTE3OXww&ixlib=rb-4.1.0&q=85"
    }
  ];

  return (
    <div className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-luxury-navy luxury-heading mb-4">
            Explore Our World
          </h2>
          <div className="w-24 h-1 bg-luxury-gold mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ctaItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={index}
                to={item.link}
                className="group relative overflow-hidden rounded-xl premium-shadow-hover border-2 border-transparent hover:border-luxury-gold"
              >
                <div className="relative h-96">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-luxury-navy/90 via-luxury-navy/50 to-transparent" />
                  <div className="absolute inset-0 bg-luxury-gold/0 group-hover:bg-luxury-gold/10 transition-colors duration-500" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                    <div className="w-16 h-16 rounded-full bg-luxury-gold/20 backdrop-blur-sm flex items-center justify-center mb-6 group-hover:bg-luxury-gold/30 transition-colors duration-500">
                      <IconComponent className="w-8 h-8 text-luxury-gold group-hover:scale-110 transition-transform duration-500" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold mb-3 text-center luxury-heading group-hover:text-luxury-gold transition-colors duration-500">
                      {item.title}
                    </h2>
                    <div className="w-12 h-px bg-luxury-gold mb-3"></div>
                    <p className="text-sm text-gray-200">{item.subtitle}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CTASections;
